// This hook adds the `mn_hasMessage` class for styling onboarding slides with a message
import { useEffect } from 'react';

export const useMessageClass = (shouldAddClass) => {
  useEffect(() => {
    if (shouldAddClass) {
      const element = document.querySelector('.mn_onboarding .mn_slide');
      element?.classList.add('mn_hasMessage');
    }
  }, [shouldAddClass]);
};
